import React, {useEffect, useState} from "react"
import {Redirect, RouteComponentProps} from "react-router"
import {Icon, Typography} from "antd"
import library from "../../library"
import "./styles.scss"

const {messages} = library
const {Text} = Typography

type Params = {
	token: string
}

export let Confirm: React.FC<RouteComponentProps<Params>>
Confirm = ({match: {params: {token}}}: RouteComponentProps<Params>) => {
	const [message, setMessage] = useState(messages.PLEASE_WAIT),
		[icon, setIcon] = useState("loading")

	const confirmUser = async (token: string) => {
		try {
			const decoded = atob(token)
			const [email, stage] = decoded.split("%")
			if (!email || !stage) throw new Error(messages.MALFORMED_TOKEN)
			if (!(email.includes("@") && email.split("@")[1].includes("."))) throw new Error(messages.MALFORMED_TOKEN)

			const preCheckResponse = await library.postQuery(
				`mutation { checkVerificationStatus(email:"${email}") }`
				, stage)

			if (preCheckResponse.checkVerificationStatus.success) {
				setMessage(messages.ALREADY_CONFIRMED)
				setIcon("check")
			} else {

				const res = await library.postQuery(`mutation { verifyAccount(token:"${token}") }`, stage)
				if (res.verifyAccount.success) {
					setIcon("check")
					setMessage(messages.CONFIRMED)
				} else {
					setIcon("warning")
					setMessage(messages.MALFORMED_TOKEN)
				}
			}
		} catch (error) {
			setIcon("warning")
			const errorMessage = error.message.includes('invalid character') ? messages.MALFORMED_TOKEN : error.message
			setMessage(errorMessage)
		}
	}

	useEffect(() => {
		if (!token) return
		confirmUser(token).then()
	}, [token])

	if (!token) return <Redirect to="/"/>

	return <Text><Icon type={icon} className="icon"/> {message}</Text>
}

export default Confirm